import {decode} from 'base64-arraybuffer'

export const createBlob = (base64, type = 'application/pdf', name = 'document.pdf') => {
    var data = decode(base64)
    return new Blob([data], {type: type}, name)
}



// WEBPACK FOOTER //
// ./src/shared/utils/createBlob.js